import statusLabels from 'enums/curative_requirement_statuses.json';
import priorityLabels from 'enums/curative_requirement_priorities.json';
import type { CardCurativeRequirement } from '../../types';
import styles from './expand.module.scss';

const STATUS = statusLabels as Record<string, string>;
const PRIORITY = priorityLabels as Record<string, string>;

// Read-only curative-requirement cards for the expanded card's Curative
// accordion. Status/priority arrive as enum keys; labels come from the shared
// enum JSON (single source of truth with the interpretation form).
export const CurativeRequirements = ({
  requirements,
}: {
  requirements: CardCurativeRequirement[];
}) => (
  <div className={styles.curativeList}>
    {requirements.map((requirement) => (
      <div key={requirement.id} className={styles.curativeCard}>
        <div className={styles.curativeMeta}>
          <span>
            <span className={styles.curativeLabel}>Status</span>
            <span>{STATUS[requirement.status] ?? requirement.status}</span>
          </span>
          <span>
            <span className={styles.curativeLabel}>Priority</span>
            <span>
              {PRIORITY[requirement.priority] ?? requirement.priority}
            </span>
          </span>
        </div>
        <div className={styles.curativeDesc}>{requirement.description}</div>
      </div>
    ))}
  </div>
);
